import React, { useEffect, useRef } from 'react';
import { Root, Message } from './style';

import Modal from 'components/Common/Modal';

import Addresses from './Addresses';
import DashboardLayoutModal from './Modal';
import Sidebar from './Sidebar';

import { useDashboard } from 'dashboard';
import { inWindow } from 'utils';

const Dashboard = (props) => {
  const modal = useRef();
  const usedRef = useRef();

  const { addresses } = useDashboard();

  useEffect(() => {
    setTimeout(() => {
      const searchParams = new URLSearchParams(props.location.search);
      const address = searchParams.get('a');

      if (
        !address &&
        !Object.keys(addresses).length &&
        props.location.pathname
          .toLowerCase()
          .match(/\/(dashboard|rewards|reinvestments|transactions)$/)
      ) {
        modal.current.show();
      }
    }, 250);
  }, [addresses, props.location]);

  return (
    <>
      {inWindow() ? (
        <Root id="dashboard-layout">
          <Sidebar location={props.location} />
          <div className="over"></div>
          <div>
            {props.location.pathname.includes('/addresses') ||
            props.location.pathname.includes('/hodlers') ? (
              ''
            ) : (
              <Addresses />
            )}
            {props.children}
            <Modal usedRef={modal} onClose={() => window.scrollTo(0, 0)}>
              <Message>
                <div className="wrapper">
                  <h3>
                    Welcome to <i className="logo">&nbsp;</i> HODL
                    <span>Dash</span>
                  </h3>
                  <p>
                    View how your investment is performing and useful project
                    information in one place.
                  </p>
                  <ul>
                    <li className="rewards">BNB Rewards</li>
                    <li className="reinvestments">Reinvestments</li>
                    <li className="addresses">Project addresses and more!</li>
                  </ul>
                  <div className="buttons">
                    <a
                      className="button blue"
                      onClick={() => usedRef.current.connect()}
                    >
                      Connect your wallet
                    </a>
                    <strong>or</strong>
                    <a
                      className="button marine-blue"
                      onClick={() => usedRef.current.search()}
                    >
                      Enter wallet address
                    </a>
                  </div>
                </div>
              </Message>
            </Modal>
            <DashboardLayoutModal
              usedRef={usedRef}
              onClose={() => modal.current.hide()}
            />
          </div>
        </Root>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default Dashboard;
